import { FC } from 'react';

import { Box, Flex, keyframes } from '@chakra-ui/react';

type Props = {
  isMenuOpen: boolean;
  toggleMenu: () => void;
  hasNotification?: boolean;
};

const topLineAnimation = keyframes`
  0% {
    transform: translateY(0);
    top: 0;
  }
  50% {
    top: 50%;
    transform: translateY(-50%);
  }
  100% {
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
  }
`;

const topLineAnimationReverse = keyframes`
  0% {
    
     top: 50%;
    transform: translateY(-50%) rotate(-45deg);
  }
  50% {
    top: 50%;
    transform: translateY(-50%);
  }
  100% {
   transform: translateY(0);
    top: 0;
  }
`;

const bottomLineAnimation = keyframes`
  0% {
    transform: translateY(0);
    bottom: 0;
  }
  50% {
    bottom: 50%;
    transform: translateY(50%);
  }
  100% {
    bottom: 50%;
    transform: translateY(50%) rotate(-45deg);
  }
`;

const bottomLineAnimationReverse = keyframes`
  0% {
    bottom: 50%;
    transform: translateY(50%) rotate(45deg);
  }
  50% {
    bottom: 50%;
    transform: translateY(50%);
  }
  100% {
    transform: translateY(0);
    bottom: 0;
  }
`;

const BurgerButton: FC<Props> = ({ isMenuOpen, toggleMenu, hasNotification }: Props) => {
  return (
    <Flex alignItems="center" position="relative" zIndex="999">
      <Flex
        cursor="pointer"
        fontSize="20px"
        lineHeight="1"
        borderRadius="12px"
        transition="all 0.2s ease-in-out"
        height="24px"
        width="24px"
        alignItems="center"
        justifyContent="center"
        gap="5px"
        flexDirection="column"
        position="relative"
        onClick={() => {
          toggleMenu();
        }}
        _active={{
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
        }}
      >
        {hasNotification && (
          <Box
            w="10px"
            h="10px"
            borderRadius="10px"
            position="absolute"
            top="-2px"
            right="-4px"
            backgroundColor="#F83C3C"
            zIndex="1"
          />
        )}
        <Box w="20px" h="16px" position="absolute" left="2px" top="4px">
          <Box
            w="20px"
            h="2px"
            position="absolute"
            left="0px"
            top={isMenuOpen ? 'calc(50% - 1px)' : '0'}
            transform={isMenuOpen ? 'rotate(45deg) translateY(-50%)' : 'none'}
            backgroundColor="#fff"
            transition="all 0s ease"
            animation={
              isMenuOpen ? `${topLineAnimation} 0.3s ease forwards` : `${topLineAnimationReverse} 0.3s ease forwards`
            }
          />
          <Box
            w={isMenuOpen ? 0 : '20px'}
            h="2px"
            position="absolute"
            left="50%"
            top="50%"
            transform="translate(-50%, -50%)"
            backgroundColor="#fff"
            transition="all 0.2s ease"
          />
          <Box
            w="20px"
            h="2px"
            position="absolute"
            left="0px"
            bottom={isMenuOpen ? 'calc(50% - 1px)' : '0'}
            transform={isMenuOpen ? 'rotate(-45deg) translateY(50%)' : 'none'}
            backgroundColor="#fff"
            transition="all 0s ease"
            animation={
              isMenuOpen
                ? `${bottomLineAnimation} 0.3s ease forwards`
                : `${bottomLineAnimationReverse} 0.3s ease forwards`
            }
          />
        </Box>
      </Flex>
    </Flex>
  );
};

export default BurgerButton;
